import KeyCollectionSiteService from "@/services/keycollection/site.service";

export const keyCollectionSite = {
    state: () => ({ 
       stateName: "KeyCollectionSiteActivation", 
    }),
    namespaced: true,
    actions: {
        view({ commit }, request) {
            return KeyCollectionSiteService.view(request)
        },
        company({ commit }) {
            return KeyCollectionSiteService.company()
            .then(
                response => {
                    return Promise.resolve(response);
                },
                error => {
                    return Promise.reject(error);
                }
            )
        },
        create({ commit, state }, request) {
            return KeyCollectionSiteService.create(request)
            .then(
                response => {
                    if(response.status === 200 && response.data.data) {
                        commit("paginator/insertRecordToPaginator", {
                            stateName: state.stateName,
                            dataToInsert: response.data.data
                        }, { root: true });
                    }
                    return Promise.resolve(response);
                },
                error => {
                    return Promise.reject(error);
                }
            )
        },
        activate({ commit, state }, request) {
            return KeyCollectionSiteService.activate(request)
            .then(
                response => {
                    if(response.status === 200 && response.data.data) {
                        commit("paginator/updateRecordInPaginator", {
                            stateName: state.stateName,
                            dataToUpdate: response.data.data,
                        }, { root: true });
                    }
                    return Promise.resolve(response);
                },
                error => {
                    return Promise.reject(error);
                }
            )
        },
        deactivate({ commit, state }, request) {
            return KeyCollectionSiteService.deactivate(request)
            .then(
                response => {
                    if(response.status === 200 && response.data.data) {
                        commit("paginator/updateRecordInPaginator", {
                            stateName: state.stateName,
                            dataToUpdate: response.data.data,
                        }, { root: true });
                    }
                    return Promise.resolve(response);
                },
                error => {
                    return Promise.reject(error);
                }
            )
        },
        updateModule({ commit, state }, request) {
            return KeyCollectionSiteService.updateModule(request)
            .then(
                response => {
                    if(response.status === 200 && response.data.data) {
                        commit("paginator/updateRecordInPaginator", {
                            stateName: state.stateName,
                            dataToUpdate: response.data.data,
                        }, { root: true });
                    }
                    return Promise.resolve(response);
                },
                error => {
                    return Promise.reject(error);
                }
            )
        },
    },
    mutations: {},
    getters: {
        getStateName(state) {
            return state.stateName;
        }
    }
};